// extracted by mini-css-extract-plugin
module.exports = {"pillGroup":"PillBar_pillGroup__GRv56","pillButton":"PillBar_pillButton__7W1V_"};